import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilVoicesService {
  public languageNameToCodeMapping = {
    "Afrikaans (South Africa)": "af-ZA",
    "Albanian (Albania)": "sq-AL",
    "Amharic (Ethiopia)": "am-ET",
    "Arabic (Egypt)": "ar-EG",
    "Arabic (Saudi Arabia)": "ar-SA",
    "Armenian (Armenia)": "hy-AM",
    "Azerbaijani (Azerbaijan)": "az-AZ",
    "Basque (Basque)": "eu-ES",
    "Bengali (India)": "bn-IN",
    "Bosnian (Bosnia and Herzegovina)": "bs-BA",
    "Bulgarian (Bulgaria)": "bg-BG",
    "Burmese (Myanmar)": "my-MM",
    "Catalan (Spain)": "ca-ES",
    "Chinese (Cantonese)": "zh-HK",
    "Chinese (Mandarin)": "zh-CN",
    "Chinese (Mandarin, Taiwan)": "zh-TW",
    "Croatian (Croatia)": "hr-HR",
    "Czech (Czech)": "cs-CZ",
    "Danish (Denmark)": "da-DK",
    "Dutch (Belgium)": "nl-BE",
    "Dutch (Netherlands)": "nl-NL",
    "English (Australia)": "en-AU",
    "English (Canada)": "en-CA",
    "English (Hong Kong SAR)": "en-HK",
    "English (India)": "en-IN",
    "English (Ireland)": "en-IE",
    "English (UK)": "en-GB",
    "English (US)": "en-US",
    "Estonian (Estonia)": "et-EE",
    "Filipino (Philippines)": "fil-PH",
    "Finnish (Finland)": "fi-FI",
    "French (Belgium)": "fr-BE",
    "French (Canada)": "fr-CA",
    "French (France)": "fr-FR",
    "French (Switzerland)": "fr-CH",
    "Galician (Galician)": "gl-ES",
    "Georgian (Georgia)": "ka-GE",
    "German (Austria)": "de-AT",
    "German (Germany)": "de-DE",
    "German (Switzerland)": "de-CH",
    "Greek (Greece)": "el-GR",
    "Hebrew (Israel)": "he-IL",
    "Hindi (India)": "hi-IN",
    "Hungarian (Hungary)": "hu-HU",
    "Icelandic (Iceland)": "is-IS",
    "Indonesian (Indonesia)": "id-ID",
    "Irish (Ireland)": "ga-IE",
    "Italian (Italy)": "it-IT",
    "Japanese (Japan)": "ja-JP",
    "Javanese (Indonesia)": "jv-ID",
    "Kannada (India)": "kn-IN",
    "Kazakh (Kazakhstan)": "kk-KZ",
    "Khmer (Cambodia)": "km-KH",
    "Korean (Korea)": "ko-KR",
    "Lao (Laos)": "lo-LA",
    "Latvian (Latvia)": "lv-LV",
    "Lithuanian (Lithuania)": "lt-LT",
    "Macedonian (North Macedonia)": "mk-MK",
    "Malay (Malaysia)": "ms-MY",
    "Malayalam (India)": "ml-IN",
    "Maltese (Malta)": "mt-MT",
    "Mongolian (Mongolia)": "mn-MN",
    "Nepali (Nepal)": "ne-NP",
    "Norwegian (Bokmål, Norway)": "nb-NO",
    "Pashto (Afghanistan)": "ps-AF",
    "Persian (Iran)": "fa-IR",
    "Polish (Poland)": "pl-PL",
    "Portuguese (Brazil)": "pt-BR",
    "Portuguese (Portugal)": "pt-PT",
    "Romanian (Romania)": "ro-RO",
    "Russian (Russia)": "ru-RU",
    "Serbian (Serbia)": "sr-RS",
    "Sinhala (Sri Lanka)": "si-LK",
    "Slovak (Slovakia)": "sk-SK",
    "Slovenian (Slovenia)": "sl-SI",
    "Somali (Somalia)": "so-SO",
    "Spanish (Mexico)": "es-MX",
    "Spanish (Spain)": "es-ES",
    "Sundanese (Indonesia)": "su-ID",
    "Swahili (Kenya)": "sw-KE",
    "Swedish (Sweden)": "sv-SE",
    "Tamil (India)": "ta-IN",
    "Telugu (India)": "te-IN",
    "Thai (Thailand)": "th-TH",
    "Turkish (Türkiye)": "tr-TR",
    "Ukrainian (Ukraine)": "uk-UA",
    "Urdu (Pakistan)": "ur-PK",
    "Uzbek (Uzbekistan)": "uz-UZ",
    "Vietnamese (Vietnam)": "vi-VN",
    "Welsh (UK)": "cy-GB",
    "Zulu (South Africa)": "zu-ZA",
    "Arabic (Iraq)": "ar-IQ",
    "Arabic (Lebanon)": "ar-LB",
    "Arabic (Libya)": "ar-LY",
    "Arabic (Syria)": "ar-SY",
    "Arabic (Yemen)": "ar-YE",
    "English (Wales)": "en-CY",
    "English (Kenya)": "en-KE",
    "English (New Zealand)": "en-NZ",
    "English (Philippines)": "en-PH",
    "English (Singapore)": "en-SG",
    "English (Tanzania)": "en-TZ",
    "Spanish (California)": "es-CA",
    "Spanish (US)": "es-US",
    "Norwegian (Norway)": "no-NO",
    "Urdu (India)": "ur-IN",
    "Multi-Lingual": "multi"
  };
  public languageCodeToNameMapping = Object.fromEntries(
    Object.entries(this.languageNameToCodeMapping).map(([name, code]) => [code, name])
  );

  constructor() {
    console.log("lang count", Object.keys(this.languageNameToCodeMapping).length);
  }

  public getVoiceTags() {
    return [
      'Young',
      'Adult',
      'Middle Aged',
      'Mature',
      'Calm',
      'Sweet',
      'Confident',
      'Warm',
      'Joyful',
      'Deep',
      'Soft',
      'Casual',
      'Sassy',
      'Excited',
      'Formal',
      'Raspy',
      'Sad',
      'Balanced',
      'Soothing',
      'Professional',
      'Playful',
      'Sophisticated'
    ];
  }
  // public getLanguageName2(lang: string, withLocation = true) {
  //   console.log("getLanguageName lang", lang);
  //   // if (lang.includes('en') && !lang.includes('US') && !lang.includes('UK') && !lang.includes('GB')) {
  //   //   if (withLocation) {
  //   //     return 'English (Others)';
  //   //   } else {
  //   //     return 'English';
  //   //   }
  //   // }
  //   switch (lang) {
  //     case 'multi':
  //       return 'Multi-Lingual';
  //     case 'en-scotland':
  //     case 'en_scotland':
  //       return withLocation ? 'English (Scotland)' : 'English';
  //     case 'en':
  //     case 'en-US':
  //     case 'en_US':
  //       return withLocation ? 'English (US)' : 'English';
  //     case 'en-CA':
  //     case 'en_CA':
  //       return withLocation ? 'English (Canada)' : 'English';
  //     case 'en-GB':
  //     case 'en_GB':
  //     case 'en-UK':
  //     case 'en_UK':
  //     case 'en-GB-oxendict':
  //     case 'en_GB_oxendict':
  //     case 'British':
  //       return withLocation ? 'English (UK)' : 'English';
  //     case 'en-CY':
  //     case 'en_CY':
  //       return withLocation ? 'English (Wales)' : 'English';
  //     case 'en-AU':
  //     case 'en_AU':
  //       return withLocation ? 'English (Australia)' : 'English';
  //     case 'en-IN':
  //     case 'en_IN':
  //       return withLocation ? 'English (India)' : 'English';
  //     case 'en-ZA':
  //     case 'en_ZA':
  //       return withLocation ? 'English (South Africa)' : 'English';
  //     case 'en-IE':
  //     case 'en_IE':
  //       return withLocation ? 'English (Ireland)' : 'English';
  //     case 'en-KE':
  //     case 'en_KE':
  //       return withLocation ? 'English (Kenya)' : 'English';
  //     case 'en-NZ':
  //     case 'en_NZ':
  //       return withLocation ? 'English (New Zealand)' : 'English';
  //     case 'es-ES':
  //     case 'es_ES':
  //       return withLocation ? 'Spanish (Spain)' : 'Spanish';
  //     case 'es-MX':
  //     case 'es_MX':
  //       return withLocation ? 'Spanish (Mexico)' : 'Spanish';
  //     case 'es-CA':
  //     case 'es_CA':
  //       return withLocation ? 'Spanish (Spain)' : 'Spanish';
  //     case 'es-AR':
  //     case 'es_AR':
  //       return withLocation ? 'Spanish (Argentina)' : 'Spanish';
  //     case 'de-DE':
  //     case 'de_DE':
  //       return 'German';
  //     case 'de-AT':
  //     case 'de_AT':
  //       return withLocation ? 'German (Austria)' : 'German';
  //     case 'de-CH':
  //     case 'de_CH':
  //       return withLocation ? 'German (Switzerland)' : 'German';
  //     case 'fr-FR':
  //     case 'fr_FR':
  //       return 'French';
  //     case 'es-US':
  //     case 'es_US':
  //       return withLocation ? 'Spanish (US)' : 'Spanish';
  //     case 'it-IT':
  //     case 'it_IT':
  //       return 'Italian';
  //     case 'pl-PL':
  //     case 'pl_PL':
  //       return 'Polish';
  //     case 'nl-NL':
  //     case 'nl_NL':
  //       return 'Dutch';
  //     case 'tr-TR':
  //     case 'tr_TR':
  //       return 'Turkish';
  //     case 'no-NO':
  //     case 'no_NO':
  //     case 'nb-NO':
  //       return 'Norwegian';
  //     case 'is-IS':
  //     case 'is_IS':
  //       return 'Icelandic';
  //     case 'da-DK':
  //     case 'da_DK':
  //       return 'Danish';
  //     case 'cy-GB':
  //     case 'cy_GB':
  //       return 'Welsh';
  //     case 'zh-CN':
  //     case 'zh_CN':
  //       return withLocation ? 'Chinese (Mandarin)' : 'Chinese';
  //     case 'zh-TW':
  //     case 'zh_TW':
  //       return withLocation ? 'Chinese (Taiwanese)' : 'Chinese';
  //     case 'zh-HK':
  //     case 'zh_HK':
  //     case 'yue-HK':
  //     case 'yue_HK':
  //       return withLocation ? 'Chinese (Cantonese)' : 'Chinese';
  //     case 'ja-JP':
  //     case 'ja_JP':
  //       return 'Japanese';
  //     case 'ko-KR':
  //     case 'ko_KR':
  //     case 'ko':
  //       return 'Korean';
  //     case 'hi-HI':
  //     case 'hi_HI':
  //       return 'Hindi';
  //     case 'id-ID':
  //     case 'id_ID':
  //       return 'Indonesian';
  //     case 'ro-RO':
  //     case 'ro_RO':
  //       return 'Romanian'
  //     case 'ru-RU':
  //     case 'ru_RU':
  //       return 'Russian';
  //     case 'pt-BR':
  //     case 'pt_BR':
  //       return withLocation ? 'Portuguese (Brazil)' : 'Portuguese';
  //     case 'pt-PT':
  //     case 'pt_PT':
  //       return withLocation ? 'Portuguese (Portugal)' : 'Portuguese';
  //     case 'fr-CA':
  //     case 'fr_CA':
  //       return withLocation ? 'French (Canada)' : 'French';
  //     case 'fr-BE':
  //     case 'fr_BE':
  //       return withLocation ? 'French (Belgium)' : 'French';
  //     case 'fr-CH':
  //     case 'fr_CH':
  //       return withLocation ? 'French (Switzerland)' : 'French';
  //     case 'sv-SE':
  //     case 'sv_SE':
  //       return 'Swedish';
  //     case 'ar':
  //       return 'Arabic';
  //     case 'ar-SA':
  //     case 'ar_SA':
  //       return withLocation ? 'Arabic (Saudi Arabia)' : 'Arabic';
  //     case 'ar-AE':
  //     case 'ar_AE':
  //       return withLocation ? 'Arabic (U.A.E.)' : 'Arabic';
  //     case 'ar-EG':
  //     case 'ar_EG':
  //       return withLocation ? 'Arabic (Egypt)' : 'Arabic';
  //     case 'ar-LB':
  //     case 'ar_LB':
  //       return withLocation ? 'Arabic (Lebanon)' : 'Arabic';
  //     case 'ar-QA':
  //     case 'ar_QA':
  //       return withLocation ? 'Arabic (Qatar)' : 'Arabic';
  //     case 'ar-IQ':
  //     case 'ar_IQ':
  //       return withLocation ? 'Arabic (Iraq)' : 'Arabic';
  //     case 'ar-LY':
  //     case 'ar_LY':
  //       return withLocation ? 'Arabic (Libya)' : 'Arabic';
  //     case 'ar-YE':
  //     case 'ar_YE':
  //       return withLocation ? 'Arabic (Yemen)' : 'Arabic';
  //     case 'ar-SY':
  //     case 'ar_SY':
  //       return withLocation ? 'Arabic (Syria)' : 'Arabic';
  //     case 'cs-CZ':
  //     case 'cs_CZ':
  //       return withLocation ? 'Czech (Czech Republic)' : 'Czech';
  //     case 'el-GR':
  //     case 'el_GR':
  //       return withLocation ? 'Greek (Greece)' : 'Greek';
  //     case 'fi-FI':
  //     case 'fi_FI':
  //       return withLocation ? 'Finnish (Finland)' : 'Finnish';
  //     case 'he':
  //       return withLocation ? 'Hebrew' : 'Hebrew';
  //     case 'he-IL':
  //     case 'he_IL':
  //     case 'iw-IL':
  //     case 'iw_IL':
  //       return withLocation ? 'Hebrew (Israel)' : 'Hebrew';
  //     case 'hi-IN':
  //     case 'hi_IN':
  //       return withLocation ? 'Hindi (India)' : 'Hindi';
  //     case 'hu-HU':
  //     case 'hu_HU':
  //       return withLocation ? 'Hungarian (Hungary)' : 'Hungarian';
  //     case 'nb-NO':
  //     case 'nb_NO':
  //       return withLocation ? 'Norwegian (Bokm?l) (Norway)' : 'Norwegian';
  //     case 'nl-BE':
  //     case 'nl_BE':
  //       return withLocation ? 'Dutch (Belgium)' : 'Dutch';
  //     case 'sk-SK':
  //     case 'sk_SK':
  //       return withLocation ? 'Slovak (Slovakia)' : 'Slovak';
  //     case 'th-TH':
  //     case 'th_TH':
  //       return withLocation ? 'Thai (Thailand)' : 'Thai';
  //     case 'km-KH':
  //     case 'km_KH':
  //       return withLocation ? 'Khmer (Cambodia)' : 'Khmer';
  //     case 'in-ID':
  //     case 'in_ID':
  //       return withLocation ? 'Indonesian (Indonesia)' : 'Indonesian';
  //     case 'ne-NP':
  //     case 'ne_NP':
  //       return withLocation ? 'Nepali (Nepal)' : 'Nepali';
  //     case 'vi-VN':
  //     case 'vi_VN':
  //       return withLocation ? 'Vietnamese (Vietnam)' : 'Vietnamese';
  //     case 'si-LK':
  //     case 'si_LK':
  //       return withLocation ? 'Sinhala (Sri Lanka)' : 'Sinhala';
  //     case 'bn-BD':
  //     case 'bn_BD':
  //       return withLocation ? 'Bengali (Bangladesh)' : 'Bengali';
  //     case 'bn-IN':
  //     case 'bn_IN':
  //       return withLocation ? 'Bengali (India)' : 'Bengali';
  //     case 'uk-UA':
  //     case 'uk_UA':
  //       return withLocation ? 'Ukrainian (Ukraine)' : 'Ukrainian';
  //     case 'fil-PH':
  //     case 'fil_PH':
  //       return withLocation ? 'Filipino (Philippines)' : 'Filipino';
  //     case 'gu-IN':
  //     case 'gu_IN':
  //       return withLocation ? 'Gujarati (India)' : 'Gujarati';
  //     case 'te-IN':
  //     case 'te_IN':
  //       return withLocation ? 'Telugu (India)' : 'Telugu';
  //     case 'kn-IN':
  //     case 'kn_IN':
  //       return withLocation ? 'Kannada (India)' : 'Kannada';
  //     case 'ta-IN':
  //     case 'ta_IN':
  //       return withLocation ? 'Tamil (India)' : 'Tamil';
  //     case 'en-NG':
  //     case 'en_NG':
  //       return withLocation ? 'English (Nigeria)' : 'English';
  //     case 'ml-IN':
  //     case 'ml_IN':
  //       return withLocation ? 'Malayalam (India)' : 'Malayalam';
  //     case 'ur-PK':
  //     case 'ur_PK':
  //       return withLocation ? 'Urdu (Pakistan)' : 'Malayalam';
  //     case 'su-ID':
  //     case 'su_ID':
  //       return withLocation ? 'Sundanese (Indonesia)' : 'Sundanese';
  //     case 'et-EE':
  //     case 'et_EE':
  //       return withLocation ? 'Estonian (Estonia)' : 'Estonian';
  //     case 'jv-ID':
  //     case 'jv_ID':
  //       return withLocation ? 'Javanese (Indonesia)' : 'Javanese';
  //     case 'mr-IN':
  //     case 'mr_IN':
  //       return withLocation ? 'Marathi (India)' : 'Marathi';
  //     case 'bg-BG':
  //     case 'bg_BG':
  //       return withLocation ? 'Bulgarian (Bulgaria)' : 'Bulgarian';
  //     case 'bs-BA':
  //     case 'bs_BA':
  //       return withLocation ? 'Bosnian (Bosnia and Herzegovina)' : 'Bosnian';
  //     case 'lv-LV':
  //     case 'lv_LV':
  //       return withLocation ? 'Latvian (Latvia)' : 'Latvian';
  //     case 'ms-MY':
  //     case 'ms_MY':
  //       return withLocation ? 'Malay (Malaysia)' : 'Malay';
  //     case 'pa-IN':
  //     case 'pa_IN':
  //       return withLocation ? 'Punjabi (India)' : 'Punjabi';
  //     case 'sq-AL':
  //     case 'sq_AL':
  //       return withLocation ? 'Albanian (Albania)' : 'Albanian';
  //     case 'sw-KE':
  //     case 'sw_KE':
  //       return withLocation ? 'Swahili (Kenya)' : 'Swahili';
  //     case 'ca-ES':
  //     case 'ca_ES':
  //       return withLocation ? 'Catalan' : 'Catalan';
  //     case 'ga-IE':
  //     case 'ga_IE':
  //       return withLocation ? 'Irish' : 'Irish';
  //     case 'hr-HR':
  //     case 'hr_HR':
  //       return withLocation ? 'Croatian' : 'Croatian';
  //     case 'ka-GE':
  //     case 'ka_GE':
  //       return withLocation ? 'Georgian' : 'Georgian';
  //     case 'ur-IN':
  //     case 'ur_IN':
  //       return withLocation ? 'Urdu' : 'Urdu';
  //   }
  //   return lang;
  // }

  public getLanguageName(lang: string, withLocation = true) {
    console.log("getLanguageName lang", lang);
    if (lang === 'multi') {
      return 'Multi-Lingual';
    }
    lang = lang.replace("_", "-");
    if (this.languageCodeToNameMapping[lang]) {
      let languageName = this.languageCodeToNameMapping[lang];
      if (withLocation) {
        return languageName;
      } else {
        return languageName.split('(')[0].trim();
      }
    }
    return lang;
  }

  public getLanguageAndLocaleForVoiceList(language) {
    let languageName = '';
    let localeName = this.getLocaleName(language);
    let displayLocale = true;
    // if (language.includes('en')) {
    languageName = this.getLanguageName(language, true);
    // if (!languageName.includes('Others')) {
    //   displayLocale = false;
    // }
    // } else {
    //   languageName = this.getLanguageName(language, false);
    // }
    return { languageName, localeName, displayLocale };
  }

  public getLocaleName(lang: string) {
    if (!lang) {
      return 'US';
    }
    let locale = '';
    if (lang.includes('-')) {
      locale = lang.split('-')[1];
    } else if (lang.includes('_')) {
      locale = lang.split('_')[1];
    }
    switch (locale) {
      case 'US':
        return 'US';
      case 'GB':
      case 'UK':
        return 'UK';
      case 'CA':
        if (lang.includes('es')) {
          return 'Spain';
        } else {
          return 'Canada';
        }
      case 'AU':
        return 'Australia';
      case 'CY':
        return 'Wales';
      case 'IN':
        return 'India';
      case 'ZA':
        return 'South Africa';
      case 'IE':
        return 'Ireland';
      case 'CN':
        return 'Mandarin';
      case 'TW':
        return 'Taiwanese';
      case 'HK':
        return 'Cantonese';
      case 'AE':
        return 'U.A.E';
      case 'SA':
        return 'Saudi Arabia';
      case 'EG':
        return 'Egypt';
      case 'LB':
        return 'Lebanon';
      case 'QA':
        return 'Qatar';
      case 'IQ':
        return 'Iraq';
      case 'LY':
        return 'Libya';
      case 'YE':
        return 'Yemen';
      case 'SY':
        return 'Syria';
      case 'BR':
        return 'Brazil';
      case 'PT':
        return 'Portugal';
      case 'IL':
        return 'Israel';
      case 'ES':
        return 'Spain';
      case 'MX':
        return 'Mexico';
      case 'AT':
        return 'Austria';
      case 'CH':
        return 'Switzerland';
      case 'BE':
        return 'Belgium';
      case 'FR':
        return 'France';
      case 'DE':
        return 'Germany';
      case 'SG':
        return 'Singapore';
      case 'KE':
        return 'Kenya';
      case 'NZ':
        return 'New Zealand';
      case 'PH':
        return 'Philippines';
      case 'TZ':
        return 'Tanzania';
      case 'AL':
        return 'Albania';
      case 'ET':
        return 'Ethiopia';
      case 'AM':
        return 'Armenia';
      case 'AZ':
        return 'Azerbaijan';
      case 'EU':
        return 'Basque';
      case 'IN':
        return 'Bengali';
      case 'BA':
        return 'Bosnia and Herzegovina';
      case 'BG':
        return 'Bulgaria';
      case 'MM':
        return 'Myanmar';
      case 'CA':
        return 'Catalan';
      case 'HR':
        return 'Croatia';
      case 'CZ':
        return 'Czech';
      case 'DK':
        return 'Denmark';
      case 'NL':
        return 'Netherlands';
      case 'EE':
        return 'Estonia';
      case 'FI':
        return 'Finland';
      case 'GL':
        return 'Galician';
      case 'GE':
        return 'Georgia';
      case 'GR':
        return 'Greece';
      case 'HU':
        return 'Hungary';
      case 'IS':
        return 'Iceland';
      case 'ID':
        return 'Indonesia';
      case 'IT':
        return 'Italy';
      case 'JP':
        return 'Japan';
      case 'JV':
        return 'Javanese';
      case 'KN':
        return 'Kannada';
      case 'KZ':
        return 'Kazakhstan';
      case 'KH':
        return 'Cambodia';
      case 'KR':
        return 'Korea';
      case 'LA':
        return 'Laos';
      case 'LV':
        return 'Latvia';
      case 'LT':
        return 'Lithuania';
      case 'MK':
        return 'North Macedonia';
      case 'MY':
        return 'Malaysia';
      case 'ML':
        return 'Malayalam';
      case 'MT':
        return 'Malta';
      case 'MN':
        return 'Mongolia';
      case 'NP':
        return 'Nepal';
      case 'NO':
        return 'Norway';
      case 'AF':
        return 'Afghanistan';
      case 'IR':
        return 'Iran';
      case 'PL':
        return 'Poland';
      case 'RO':
        return 'Romania';
      case 'RU':
        return 'Russia';
      case 'RS':
        return 'Serbia';
      case 'LK':
        return 'Sri Lanka';
      case 'SK':
        return 'Slovakia';
      case 'SI':
        return 'Slovenia';
      case 'SO':
        return 'Somalia';
      case 'SE':
        return 'Sweden';
      case 'TA':
        return 'Tamil';
      case 'TE':
        return 'Telugu';
      case 'TH':
        return 'Thailand';
      case 'TR':
        return 'Türkiye';
      case 'UA':
        return 'Ukraine';
      case 'PK':
        return 'Pakistan';
      case 'UZ':
        return 'Uzbekistan';
      case 'VN':
        return 'Vietnam';
      case 'ZU':
        return 'Zulu';
      default:
        return '';
    }
  }

  public getLocationAndLangName(lang: string) {
    switch (lang) {
      case 'fr-FR':
        return 'FrenchFrance';
      case 'fr-CA':
        return 'FrenchCanada';
      case 'fr-CH':
        return 'FrenchSwitzerland';
      case 'fr-BE':
        return 'FrenchBelgium';
      case 'en-AU':
        return 'EnglishAustralia';
      case 'en-IN':
        return 'EnglishIndia';
      case 'en-GB':
        return 'EnglishUk';
      case 'en-US':
        return 'EnglishUs';
      case 'en-CY':
        return 'EnglishWales';
      case 'en-IE':
        return 'EnglishIreland';
      case 'en-TZ':
        return 'EnglishTanzania';
      case 'en-NZ':
        return 'EnglishNewZealand';
      case 'en-KE':
        return 'EnglishKenya';
      case 'en-PH':
        return 'EnglishPhilippines';
      case 'en-SG':
        return 'EnglishSingapore';
      case 'pt-PT':
        return 'PortuguesePortugal';
      case 'pt-BR':
        return 'PortugueseBrazil';
      case 'es-ES':
      case 'es-CA':
        return 'SpanishSpain';
      case 'es-US':
        return 'SpanishUs';
      case 'es-MX':
        return 'SpanishMexico';
      case 'nl-BE':
        return 'DutchBelgium';
      case 'de-DE':
        return 'GermanGermany';
      case 'de-AT':
        return 'GermanAustria';
      case 'de-CH':
        return 'GermanSwitzerland';

    }
    return this.getLanguageName(lang, false);
  }

  public getLangCode(langName: string) {
    const langCodes = {
      'English': 'en',
      'Arabic': 'ar',
      // 'Chinese': 'zh',
      'Chinese': 'zh-Hans',
      'Danish': 'da',
      'Dutch': 'nl',
      'Filipino': 'fil',
      'Finnish': 'fi',
      'French': 'fr',
      'German': 'de',
      'Hindi': 'hi',
      'Icelandic': 'is',
      'Indonesian': 'id',
      'Italian': 'it',
      'Japanese': 'ja',
      // 'Korean': 'kr',
      'Korean': 'ko',
      'Norwegian': 'no',
      'Polish': 'pl',
      'Portuguese': 'pt',
      'Romanian': 'ro',
      'Russian': 'ru',
      'Spanish': 'es',
      'Swedish': 'sv',
      // 'Thai': 'th',
      'Thai': 'unk',
      'Turkish': 'tr',
      // 'Vietnamese': 'vi'
      'Vietnamese': 'unk',
      'Auto': 'unk',
    }

    return langCodes[langName];
  }

  public getIcon(language, name) {
    const urlPrefix = 'https://wwwnaturalreaderscom.s3.amazonaws.com/pw-portraits/';
    const langName = this.getLanguageName(language, false).toLowerCase();

    console.log("getIcon langName", name, langName, language);
    let voiceName = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    if (voiceName.includes("Emma")) {
      if (language.includes("US")) {
        voiceName += "EmmaUS";
      }
      if (language.includes("UK")) {
        voiceName += "EmmaUK";
      }
    }
    return urlPrefix + langName + '/' + (langName === 'english' ? (voiceName + '.jpg') : (voiceName.split(" (")[0] + '.jpg'));
  }

  getLanguagesName(lang, withLocation = true) {
    switch (lang) {
      // case 'en':
      //   return 'English';
      case 'multi':
        return 'Multi-Lingual';
      case 'en-scotland':
      case 'en_scotland':
        return withLocation ? 'English (Scotland)' : 'English';
      case 'en':
      case 'en-US':
      case 'en_US':
        return withLocation ? 'English (US)' : 'English';
      case 'en-GB':
      case 'en_GB':
      case 'en-UK':
      case 'en_UK':
      case 'en-GB-oxendict':
      case 'en_GB_oxendict':
      case 'British':
        return withLocation ? 'English (UK)' : 'English';
      case 'en-CY':
      case 'en_CY':
        return withLocation ? 'English (Wales)' : 'English';
      case 'en-AU':
      case 'en_AU':
        return withLocation ? 'English (Australia)' : 'English';
      case 'en-IN':
      case 'en_IN':
        return withLocation ? 'English (India)' : 'English';
      case 'en-ZA':
      case 'en_ZA':
        return withLocation ? 'English (South Africa)' : 'English';
      case 'en-IE':
      case 'en_IE':
        return withLocation ? 'English (Ireland)' : 'English';
      case 'en-NZ':
      case 'en_NZ':
        return withLocation ? 'English (New Zealand)' : 'English';
      case 'es-ES':
      case 'es_ES':
        return withLocation ? 'Spanish (Spain)' : 'Spanish';
      case 'es-MX':
      case 'es_MX':
        return withLocation ? 'Spanish (Mexico)' : 'Spanish';
      case 'es-CA':
      case 'es_CA':
        return withLocation ? 'Spanish (Spain)' : 'Spanish';
      case 'es-AR':
      case 'es_AR':
        return withLocation ? 'Spanish (Argentina)' : 'Spanish';
      case 'de-DE':
      case 'de_DE':
        return 'German';
      case 'de-AT':
      case 'de_AT':
        return withLocation ? 'German (Austria)' : 'German';
      case 'de-CH':
      case 'de_CH':
        return withLocation ? 'German (Switzerland)' : 'German';
      case 'fr-FR':
      case 'fr_FR':
        return 'French';
      case 'fr-BE':
      case 'fr_BE':
        return withLocation ? 'French (Belgium)' : 'French';
      case 'fr-CH':
      case 'fr_CH':
        return withLocation ? 'French (Switzerland)' : 'French';
      case 'es-US':
      case 'es_US':
        return withLocation ? 'Spanish (US)' : 'Spanish';
      case 'it-IT':
      case 'it_IT':
        return 'Italian';
      case 'pl-PL':
      case 'pl_PL':
        return 'Polish';
      case 'nl-NL':
      case 'nl_NL':
        return 'Dutch';
      case 'tr-TR':
      case 'tr_TR':
        return 'Turkish';
      case 'no-NO':
      case 'no_NO':
      case 'nb-NO':
        return 'Norwegian';
      case 'is-IS':
      case 'is_IS':
        return 'Icelandic';
      case 'da-DK':
      case 'da_DK':
        return 'Danish';
      case 'cy-GB':
      case 'cy_GB':
        return 'Welsh';
      case 'zh-CN':
      case 'zh_CN':
      case 'zh-TW':
      case 'zh_TW':
        return withLocation ? 'Chinese (Mandarin, Taiwan)' : 'Chinese';
      case 'zh-HK':
      case 'zh_HK':
      case 'yue-HK':
      case 'yue_HK':
        return withLocation ? 'Chinese (Cantonese)' : 'Chinese';
      case 'ja-JP':
      case 'ja_JP':
        return 'Japanese';
      case 'ko-KR':
      case 'ko_KR':
        return 'Korean';
      case 'hi-HI':
      case 'hi_HI':
        return 'Hindi';
      case 'id-ID':
      case 'id_ID':
        return 'Indonesian';
      case 'ro-RO':
      case 'ro_RO':
        return 'Romanian'
      case 'ru-RU':
      case 'ru_RU':
        return 'Russian';
      case 'pt-BR':
      case 'pt_BR':
        return withLocation ? 'Portuguese (Brazil)' : 'Portuguese';
      case 'pt-PT':
      case 'pt_PT':
        return withLocation ? 'Portuguese (Portugal)' : 'Portuguese';
      case 'fr-CA':
      case 'fr_CA':
        return withLocation ? 'French (Canada)' : 'French';
      case 'sv-SE':
      case 'sv_SE':
        return 'Swedish';
      case 'ar-SA':
      case 'ar_SA':
        return withLocation ? 'Arabic (Saudi Arabia)' : 'Arabic';
      case 'ar-AE':
      case 'ar_AE':
        return withLocation ? 'Arabic (U.A.E.)' : 'Arabic';
      case 'ar-EG':
      case 'ar_EG':
        return withLocation ? 'Arabic (Egypt)' : 'Arabic';
      case 'ar-LB':
      case 'ar_LB':
        return withLocation ? 'Arabic (Lebanon)' : 'Arabic';
      case 'ar-QA':
      case 'ar_QA':
        return withLocation ? 'Arabic (Qatar)' : 'Arabic';
      case 'ar-IQ':
      case 'ar_IQ':
        return withLocation ? 'Arabic (Iraq)' : 'Arabic';
      case 'ar-LY':
      case 'ar_LY':
        return withLocation ? 'Arabic (Libya)' : 'Arabic';
      case 'ar-YE':
      case 'ar_YE':
        return withLocation ? 'Arabic (Yemen)' : 'Arabic';
      case 'ar-SY':
      case 'ar_SY':
        return withLocation ? 'Arabic (Syria)' : 'Arabic';
      case 'cs-CZ':
      case 'cs_CZ':
        return withLocation ? 'Czech (Czech Republic)' : 'Czech';
      case 'el-GR':
      case 'el_GR':
        return withLocation ? 'Greek (Greece)' : 'Greek';
      case 'fi-FI':
      case 'fi_FI':
        return withLocation ? 'Finnish (Finland)' : 'Finnish';
      case 'he':
        return withLocation ? 'Hebrew' : 'Hebrew';
      case 'he-IL':
      case 'he_IL':
      case 'iw-IL':
      case 'iw_IL':
        return withLocation ? 'Hebrew (Israel)' : 'Hebrew';
      case 'hi-IN':
      case 'hi_IN':
        return withLocation ? 'Hindi (India)' : 'Hindi';
      case 'hu-HU':
      case 'hu_HU':
        return withLocation ? 'Hungarian (Hungary)' : 'Hungarian';
      case 'nb-NO':
      case 'nb_NO':
        return withLocation ? 'Norwegian (Bokm?l) (Norway)' : 'Norwegian';
      case 'nl-BE':
      case 'nl_BE':
        return withLocation ? 'Dutch (Belgium)' : 'Dutch';
      case 'sk-SK':
      case 'sk_SK':
        return withLocation ? 'Slovak (Slovakia)' : 'Slovak';
      case 'th-TH':
      case 'th_TH':
        return withLocation ? 'Thai (Thailand)' : 'Thai';
      case 'km-KH':
      case 'km_KH':
        return withLocation ? 'Khmer (Cambodia)' : 'Khmer';
      case 'in-ID':
      case 'in_ID':
        return withLocation ? 'Indonesian (Indonesia)' : 'Indonesian';
      case 'ne-NP':
      case 'ne_NP':
        return withLocation ? 'Nepali (Nepal)' : 'Nepali';
      case 'vi-VN':
      case 'vi_VN':
        return withLocation ? 'Vietnamese (Vietnam)' : 'Vietnamese';
      case 'si-LK':
      case 'si_LK':
        return withLocation ? 'Sinhala (Sri Lanka)' : 'Sinhala';
      case 'bn-BD':
      case 'bn_BD':
        return withLocation ? 'Bengali (Bangladesh)' : 'Bengali';
      case 'bn-IN':
      case 'bn_IN':
        return withLocation ? 'Bengali (India)' : 'Bengali';
      case 'uk-UA':
      case 'uk_UA':
        return withLocation ? 'Ukrainian (Ukraine)' : 'Ukrainian';
      case 'fil-PH':
      case 'fil_PH':
        return withLocation ? 'Filipino (Philippines)' : 'Filipino';
      case 'gu-IN':
      case 'gu_IN':
        return withLocation ? 'Gujarati (India)' : 'Gujarati';
      case 'te-IN':
      case 'te_IN':
        return withLocation ? 'Telugu (India)' : 'Telugu';
      case 'kn-IN':
      case 'kn_IN':
        return withLocation ? 'Kannada (India)' : 'Kannada';
      case 'ta-IN':
      case 'ta_IN':
        return withLocation ? 'Tamil (India)' : 'Tamil';
      case 'en-NG':
      case 'en_NG':
        return withLocation ? 'English (Nigeria)' : 'English';
      case 'ar':
        return 'Arabic';
      case 'ml-IN':
      case 'ml_IN':
        return withLocation ? 'Malayalam (India)' : 'Malayalam';
      case 'ur-PK':
      case 'ur_PK':
        return withLocation ? 'Urdu (Pakistan)' : 'Malayalam';
      case 'su-ID':
      case 'su_ID':
        return withLocation ? 'Sundanese (Indonesia)' : 'Sundanese';
      case 'et-EE':
      case 'et_EE':
        return withLocation ? 'Estonian (Estonia)' : 'Estonian';
      case 'jv-ID':
      case 'jv_ID':
        return withLocation ? 'Javanese (Indonesia)' : 'Javanese';
      case 'mr-IN':
      case 'mr_IN':
        return withLocation ? 'Marathi (India)' : 'Marathi';
      case 'bg-BG':
      case 'bg_BG':
        return withLocation ? 'Bulgarian (Bulgaria)' : 'Bulgarian';
      case 'bs-BA':
      case 'bs_BA':
        return withLocation ? 'Bosnian (Bosnia and Herzegovina)' : 'Bosnian';
      case 'lv-LV':
      case 'lv_LV':
        return withLocation ? 'Latvian (Latvia)' : 'Latvian';
      case 'ms-MY':
      case 'ms_MY':
        return withLocation ? 'Malay (Malaysia)' : 'Malay';
      case 'pa-IN':
      case 'pa_IN':
        return withLocation ? 'Punjabi (India)' : 'Punjabi';
      case 'sq-AL':
      case 'sq_AL':
        return withLocation ? 'Albanian (Albania)' : 'Albanian';
      case 'sw-KE':
      case 'sw_KE':
        return withLocation ? 'Swahili (Kenya)' : 'Swahili';
    }
    return lang;
  }

  // deprecated
  sortLanguages(languages) {
    return languages.sort(function (a: string, b: string) {
      if (a.includes('Cloned') && !b.includes('Cloned')) {
        return -1;
      } else if (!a.includes('Cloned') && b.includes('Cloned')) {
        return 1;
      } else if (a.includes('Multi-Lingual') && !b.includes('Multi-Lingual')) {
        return -1;
      } else if (!a.includes('Multi-Lingual') && b.includes('Multi-Lingual')) {
        return 1;
      } else if (a.includes('English') && !b.includes('English')) {
        return -1;
      } else if (!a.includes('English') && b.includes('English')) {
        return 1;
      } else if (a.includes('English') && b.includes('English')) {
        let locales = ['US', 'UK', 'Australia', 'India', 'Nigeria', 'Wales'];

        let aMatchArray = a.match(/\(([^)]+)\)/);
        let bMatchArray = b.match(/\(([^)]+)\)/);
        if ((aMatchArray == null || aMatchArray.length < 2) && (bMatchArray == null || bMatchArray.length < 2)) {
          return 0;
        }
        if (aMatchArray == null || aMatchArray.length < 2) {
          return -1;
        }
        if (bMatchArray == null || bMatchArray.length < 2) {
          return 1;
        }

        let aLocale = aMatchArray[1];
        let bLocale = bMatchArray[1];
        if (aLocale == bLocale) {
          return 0;
        }
        let aIndex = locales.indexOf(aLocale);
        let bIndex = locales.indexOf(bLocale);
        if (aIndex == -1 || bIndex == -1) {
          return 1;
        }
        return (aIndex < bIndex) ? -1 : (aIndex > bIndex) ? 1 : 0;
      } else {
        return (a < b) ? -1 : (a > b) ? 1 : 0;
      }
    });
  }
}
